/**
 * Pestanas que el portal WEB de agentes sabe pintar: las que tienen `<Route>`
 * en App.tsx bajo `/admin/agent/*`.
 *
 * El menu del agente (submenus del menu 16) lo comparten la web y la app movil
 * (sozu-agente-app). La app tiene pantallas que la web no, como
 * `/admin/agent/notificaciones`, y pintarlas aqui daria un enlace que cae en el
 * catch-all y rebota a Inicio. Agregar una pestana web = su `<Route>` + esta
 * lista (el test `agentPortalRutas.test.ts` cruza ambas).
 */
export const AGENT_PORTAL_WEB_RUTAS = [
  '/admin/agent/inicio',
  '/admin/agent/inventario',
  '/admin/agent/prospectos',
  '/admin/agent/pipeline',
  '/admin/agent/comisiones',
  '/admin/agent/material',
  '/admin/agent/perfil',
] as const;

export type AgentPortalWebRuta = (typeof AGENT_PORTAL_WEB_RUTAS)[number];

const RUTAS = new Set<string>(AGENT_PORTAL_WEB_RUTAS);

export const esRutaDelPortalWeb = (ruta: string | null | undefined): ruta is AgentPortalWebRuta =>
  !!ruta && RUTAS.has(ruta);

/** Deja solo los submenus que la web puede abrir; los exclusivos de la app se omiten. */
export function soloSubmenusDelPortalWeb<T extends { vista_front_end: string | null }>(
  submenus: readonly T[],
): Array<T & { vista_front_end: AgentPortalWebRuta }> {
  return submenus.filter(
    (s): s is T & { vista_front_end: AgentPortalWebRuta } => esRutaDelPortalWeb(s.vista_front_end),
  );
}

/** Menu del agente en `menus`: lo comparten el portal web y la app movil. */
export const AGENT_MENU_ID = 16;

/**
 * A donde manda el enlace del portal en el sidebar del admin: la primera
 * pestana (ya en `orden`) que la web puede abrir. En el menu del agente se
 * saltan las de la app, asi Notificaciones puede ir primero sin romperlo.
 * Sin ninguna ruta web, se queda la primera, como antes.
 */
export function hrefDeEntradaAlPortal(menuId: number, hrefs: readonly string[]): string | undefined {
  if (menuId !== AGENT_MENU_ID) return hrefs[0];
  return hrefs.find(h => esRutaDelPortalWeb(h)) ?? hrefs[0];
}
